import { render, staticRenderFns } from "./PostAiGenerativeJob.vue?vue&type=template&id=1e87219e&scoped=true"
import script from "./PostAiGenerativeJob.vue?vue&type=script&lang=ts"
export * from "./PostAiGenerativeJob.vue?vue&type=script&lang=ts"
import style0 from "./PostAiGenerativeJob.vue?vue&type=style&index=0&id=1e87219e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e87219e",
  null
  
)

export default component.exports